<template>
  <div style="display: inline-block; vertical-align: inherit;padding-left: 25px;">
    <div v-if="loaded" class="group-badge" v-for="userDepartment in data">
      <user-department-badge-component :key="userDepartment.id" :user-department="userDepartment"
                                       :display-name="!collapse" :border="collapse"></user-department-badge-component>
    </div>
    <div v-bind:class="{hidden: hasMultiple}" v-if="!loaded" style="margin-left:-2.5rem;">
      <Skeleton :circle="true" :height="33" :width="33" :loading="!loaded"
                style="vertical-align: middle;"></Skeleton>
      <Skeleton :height="20" :width="40" :loading="!loaded" style="vertical-align: middle;"></Skeleton>
    </div>
    <div v-bind:class="{hidden: !hasMultiple}" v-if="!loaded" style="margin-left:-2.5rem;">
      <Skeleton v-for="(n,index) in userDepartmentCount" :key="index" :circle="true" :height="33" :width="33"
                :loading="!loaded" style="vertical-align: middle;margin-right:-1.8rem;"></Skeleton>
    </div>
  </div>
</template>

<script>
import userDepartmentApi from '~/api/user_department'
import { Skeleton } from 'vue-loading-skeleton'
import UserDepartmentBadgeComponent from '../../user_department/components/BadgeComponent'

export default {
  name: 'UserDepartmentBadgeGroupComponent',
  components: { UserDepartmentBadgeComponent, Skeleton },
  props: {
    userDepartments: {
      type: Array,
      required: false,
      default: () => ([])
    },
    userDepartmentIds: {
      type: Array,
      required: false,
      default: () => ([])
    }
  },
  data () {
    return {
      data: [],
      loaded: false,
    }
  },
  computed: {
    collapse: function () {
      return (this.data.length) > 1
    },
    hasMultiple: function () {
      return this.userDepartments.length > 1 || this.userDepartmentIds.length > 1
    },
    userDepartmentCount: function () {
      return this.userDepartments.length || this.userDepartmentIds.length || 0
    },
  },
  mounted () {
    if (this.userDepartments.length === 0 && this.userDepartmentIds.length > 0) {
      userDepartmentApi.getByIds(this.userDepartmentIds).then(response => {
        this.data = response.data
        this.loaded = true
      })
    } else {
      this.data = this.userDepartments
      this.loaded = true
    }
  }
}
</script>
<style>
.department-badge {
  vertical-align: inherit;
  display: inline-block;
  padding: 0.5rem;
  margin: -.5rem 0;
  border-radius: .2rem;
  transition: background-color .5s;
}

.department-badge:hover {
  background-color: #0000000a;
}

.department-badge .white-border {
  border-radius: 100%;
  border: solid white 2px;
}
</style>